import {
  __decorateClass
} from "./chunk-QUKACBNK.js";

// src/components/layout.ts
import {
  html as html4,
  LitElement as LitElement3
} from "@spectrum-web-components/base";
import {
  property as property3,
  state
} from "@spectrum-web-components/base/src/decorators.js";
import {
  trigger
} from "@spectrum-web-components/overlay/src/overlay-trigger-directive.js";
import {
  DARK_MODE,
  IS_MOBILE
} from "@spectrum-web-components/reactive-controllers/src/MatchMedia.js";
import "@spectrum-web-components/theme/sp-theme.js";
import "@spectrum-web-components/button/sp-button.js";
import "@spectrum-web-components/action-button/sp-action-button.js";
import "@spectrum-web-components/link/sp-link.js";
import "@spectrum-web-components/divider/sp-divider.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-show-menu.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-settings.js";

// src/components/adobe-logo.ts
import {
  html,
  LitElement
} from "@spectrum-web-components/base";
import {
  customElement,
  property
} from "@spectrum-web-components/base/src/decorators.js";

// src/components/adobe-logo.css
import { css } from "lit";
var styles = css`:host{display:inline-flex}`;
var adobe_logo_default = styles;

// src/components/adobe-logo.ts
var SpectrumLogo = class extends LitElement {
  constructor() {
    super(...arguments);
    this.size = "36px";
  }
  static get styles() {
    return [adobe_logo_default];
  }
  render() {
    return html`
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        viewBox="0 0 30 26"
        width=${this.size}
        xml:space="preserve"
        role="img"
        aria-label="Adobe"
      >
        <path
          fill="#FA0F00"
          d="M19 0h11v26zM11.1 0H0v26zM15 9.6L22.1 26h-4.6l-2.1-5.2h-5.2z"
        />
      </svg>
    `;
  }
};
__decorateClass([
  property({ type: String })
], SpectrumLogo.prototype, "size", 2);
SpectrumLogo = __decorateClass([
  customElement("docs-spectrum-logo")
], SpectrumLogo);

// src/components/code-example.ts
import {
  html as html3,
  LitElement as LitElement2
} from "@spectrum-web-components/base";
import {
  customElement as customElement2,
  property as property2,
  query
} from "@spectrum-web-components/base/src/decorators.js";
import { FocusVisiblePolyfillMixin } from "@spectrum-web-components/shared";
import "@spectrum-web-components/action-button/sp-action-button.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-copy.js";

// src/utils/templates.ts
import {
  css as css2,
  html as html2
} from "@spectrum-web-components/base";
function toHtmlTemplateString(code) {
  const stringArray = [`${code}`];
  stringArray.raw = [`${code}`];
  return html2(stringArray);
}

// src/components/copy-to-clipboard.ts
function createNode(text) {
  const node = document.createElement("pre");
  node.style.width = "1px";
  node.style.height = "1px";
  node.style.position = "fixed";
  node.style.top = "5px";
  node.textContent = text;
  return node;
}
function copyNode(node) {
  const text = node.textContent;
  if (!text) {
    return Promise.reject(new Error("Node has no text content"));
  }
  const customElements2 = extractNodeCustomElements(text);
  const importStatements = generateImportStatements(customElements2);
  const fullCopiedText = `${importStatements}
${node.textContent}`;
  if ("clipboard" in navigator) {
    return navigator.clipboard.writeText(fullCopiedText || "");
  }
  const selection = getSelection();
  if (selection == null) {
    return Promise.reject(new Error());
  }
  selection.removeAllRanges();
  const range = document.createRange();
  range.selectNodeContents(node);
  selection.addRange(range);
  document.execCommand("copy");
  selection.removeAllRanges();
  return Promise.resolve();
}
function extractNodeCustomElements(text) {
  const customElements2 = /* @__PURE__ */ new Set();
  const regex = /<sp-[a-zA-Z-]+/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    customElements2.add(match[0].substring(1));
  }
  return customElements2;
}
function generateImportStatements(elements) {
  let imports = "";
  elements.forEach((element) => {
    const elementName = element.substring(3);
    if (element.includes("sp-icon")) {
      imports += `import '@spectrum-web-components/icons-workflow/icons/${element}.js';
`;
    } else {
      imports += `import '@spectrum-web-components/${elementName}/${element}.js';
`;
    }
  });
  return imports;
}
function copyText(text) {
  if ("clipboard" in navigator) {
    return navigator.clipboard.writeText(text);
  }
  const body = document.body;
  if (!body) {
    return Promise.reject(new Error());
  }
  const node = createNode(text);
  body.appendChild(node);
  copyNode(node);
  body.removeChild(node);
  return Promise.resolve();
}

// src/components/code-example.css
import { css as css3 } from "lit";
var styles2 = css3`.spectrum-Button,::slotted(.spectrum-Button){--spectrum-button-sized-height:var(--spectrum-component-height-100);--spectrum-button-sized-font-size:var(--spectrum-font-size-100);--spectrum-button-sized-edge-to-visual:calc(var(--spectrum-component-pill-edge-to-visual-100) - var(--spectrum-button-border-width));--spectrum-button-sized-edge-to-visual-only:var(--spectrum-component-pill-edge-to-visual-only-100);--spectrum-button-sized-edge-to-text:calc(var(--spectrum-component-pill-edge-to-text-100) - var(--spectrum-button-border-width));--spectrum-button-sized-padding-label-to-icon:var(--spectrum-text-to-visual-100);--spectrum-button-sized-top-to-text:var(--spectrum-button-top-to-text-medium);--spectrum-button-sized-bottom-to-text:var(--spectrum-button-bottom-to-text-medium);--spectrum-button-sized-top-to-icon:var(--spectrum-component-top-to-workflow-icon-100);--spectrum-button-intended-icon-size:var(--spectrum-workflow-icon-size-100);--spectrum-button-content-color-default:var(--spectrum-neutral-content-color-default);--spectrum-button-content-color-hover:var(--spectrum-neutral-content-color-hover);--spectrum-button-content-color-down:var(--spectrum-neutral-content-color-down);--spectrum-button-content-color-focus:var(--spectrum-neutral-content-color-key-focus);--spectrum-button-height:var(--mod-button-height,var(--spectrum-button-sized-height));--spectrum-button-min-width:var(--mod-button-min-width,calc(var(--spectrum-button-height)*var(--spectrum-button-minimum-width-multiplier)));--spectrum-button-line-height:var(--mod-button-line-height,1.2);--spectrum-button-font-size:var(--mod-button-font-size,var(--spectrum-button-sized-font-size));--spectrum-button-padding-label-to-icon:var(--mod-button-padding-label-to-icon,var(--spectrum-button-sized-padding-label-to-icon));--spectrum-button-edge-to-visual:var(--mod-button-edge-to-visual,var(--spectrum-button-sized-edge-to-visual));--spectrum-button-edge-to-visual-only:var(--mod-button-edge-to-visual-only,var(--spectrum-button-sized-edge-to-visual-only));--spectrum-button-edge-to-text:var(--mod-button-edge-to-text,var(--spectrum-button-sized-edge-to-text));--spectrum-button-top-to-text:var(--mod-button-top-to-text,var(--spectrum-button-sized-top-to-text));--spectrum-button-bottom-to-text:var(--mod-button-bottom-to-text,var(--spectrum-button-sized-bottom-to-text));--spectrum-button-top-to-icon:var(--mod-button-top-to-icon,var(--spectrum-button-sized-top-to-icon));--spectrum-button-focus-ring-thickness:var(--mod-button-focus-ring-thickness,var(--spectrum-focus-indicator-thickness));--spectrum-button-focus-indicator-color:var(--mod-button-focus-ring-color,var(--spectrum-focus-indicator-color));--spectrum-button-animation-duration:var(--mod-button-animation-duration,var(--spectrum-animation-duration-100));--spectrum-button-border-width:var(--mod-button-border-width,var(--spectrum-border-width-200));--spectrum-button-focus-ring-gap:var(--mod-focus-indicator-gap,var(--mod-button-focus-ring-gap,var(--spectrum-focus-indicator-gap)));--spectrum-button-border-radius:var(--mod-button-border-radius,calc(var(--spectrum-button-height)/2));--spectrum-icon-size:var(--spectrum-workflow-icon-size-100);--spectrum-button-background-color-default:var(--system-button-background-color-default);--spectrum-button-background-color-hover:var(--system-button-background-color-hover);--spectrum-button-background-color-down:var(--system-button-background-color-down);--spectrum-button-background-color-focus:var(--system-button-background-color-focus);--spectrum-button-border-color-default:var(--system-button-border-color-default);--spectrum-button-border-color-hover:var(--system-button-border-color-hover);--spectrum-button-border-color-down:var(--system-button-border-color-down);--spectrum-button-border-color-focus:var(--system-button-border-color-focus);--spectrum-button-background-color-disabled:var(--system-button-background-color-disabled);--spectrum-button-border-color-disabled:var(--system-button-border-color-disabled);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;gap:var(--spectrum-button-padding-label-to-icon);min-inline-size:var(--spectrum-button-min-width);max-inline-size:var(--mod-button-max-inline-size,none);min-block-size:var(--spectrum-button-height);padding-block:0;padding-block-start:calc(var(--spectrum-button-top-to-text) - var(--spectrum-button-border-width));padding-block-end:calc(var(--spectrum-button-bottom-to-text) - var(--spectrum-button-border-width));padding-inline:var(--spectrum-button-edge-to-text);margin:0;margin-block:var(--mod-button-margin-block);font-family:var(--mod-button-font-family,var(--mod-sans-font-family-stack,var(--spectrum-sans-font-family-stack)));font-size:var(--spectrum-button-font-size);font-weight:var(--mod-bold-font-weight,var(--spectrum-bold-font-weight));line-height:var(--spectrum-button-line-height);vertical-align:top;color:var(--highcontrast-button-content-color-default,var(--mod-button-content-color-default,var(--spectrum-button-content-color-default,inherit)));text-align:var(--mod-button-text-align,center);text-transform:none;background-color:var(--highcontrast-button-background-color-default,var(--mod-button-background-color-default,var(--spectrum-button-background-color-default)));border-color:var(--highcontrast-button-border-color-default,var(--mod-button-border-color-default,var(--spectrum-button-border-color-default)));border-style:solid;border-width:var(--spectrum-button-border-width);border-radius:var(--spectrum-button-border-radius);appearance:auto;cursor:pointer;user-select:none;transition:outline var(--spectrum-button-animation-duration,.13s)linear,border var(--spectrum-button-animation-duration,.13s)linear,color var(--spectrum-button-animation-duration,.13s)linear,background-color var(--spectrum-button-animation-duration,.13s)linear;justify-content:center;align-self:start;align-items:center;margin-inline-start:var(--mod-button-margin-left);margin-inline-end:var(--mod-button-margin-right);text-decoration:none;display:inline-flex;position:relative;overflow:visible}.spectrum-Button:focus-visible,::slotted(.spectrum-Button:focus-visible){color:var(--highcontrast-button-content-color-focus,var(--mod-button-content-color-focus,var(--spectrum-button-content-color-focus)));background-color:var(--highcontrast-button-background-color-focus,var(--mod-button-background-color-focus,var(--spectrum-button-background-color-focus)));outline:var(--spectrum-button-focus-ring-thickness)solid var(--spectrum-button-focus-indicator-color);outline-offset:var(--mod-focus-indicator-gap,var(--spectrum-focus-indicator-gap))}.spectrum-Button:active,::slotted(.spectrum-Button:active){color:var(--highcontrast-button-content-color-down,var(--mod-button-content-color-down,var(--spectrum-button-content-color-down)));background-color:var(--highcontrast-button-background-color-down,var(--mod-button-background-color-down,var(--spectrum-button-background-color-down)));border-color:var(--highcontrast-button-border-color-down,var(--mod-button-border-color-down,var(--spectrum-button-border-color-down)));box-shadow:none}@media (hover:hover){.spectrum-Button:hover,::slotted(.spectrum-Button:hover){color:var(--highcontrast-button-content-color-hover,var(--mod-button-content-color-hover,var(--spectrum-button-content-color-hover)));background-color:var(--highcontrast-button-background-color-hover,var(--mod-button-background-color-hover,var(--spectrum-button-background-color-hover)));border-color:var(--highcontrast-button-border-color-hover,var(--mod-button-border-color-hover,var(--spectrum-button-border-color-hover)));box-shadow:none}}.spectrum-Button--iconOnly,::slotted(.spectrum-Button--iconOnly){min-inline-size:unset;padding:calc(var(--spectrum-button-edge-to-visual-only) - var(--spectrum-button-border-width));border-radius:50%}.spectrum-Button :is([slot=icon],svg,img){--spectrum-icon-size:inherit;inline-size:var(--spectrum-icon-size,var(--spectrum-workflow-icon-size-100));block-size:var(--spectrum-icon-size,var(--spectrum-workflow-icon-size-100));color:inherit;fill:currentColor;flex-shrink:0;align-self:flex-start}.spectrum-Button:not(.spectrum-Button--iconOnly) :is([slot=icon],svg,img){margin-block:calc((var(--spectrum-icon-block-size) - 1lh)/2*-1);margin-inline-start:calc(var(--mod-button-edge-to-visual,var(--spectrum-button-edge-to-visual)) - var(--mod-button-edge-to-text,var(--spectrum-button-edge-to-text)))}.spectrum-Button--sizeS,::slotted(.spectrum-Button--sizeS){--spectrum-button-sized-height:var(--spectrum-component-height-75);--spectrum-button-sized-font-size:var(--spectrum-font-size-75);--spectrum-button-sized-edge-to-visual:calc(var(--spectrum-component-pill-edge-to-visual-75) - var(--spectrum-button-border-width));--spectrum-button-sized-edge-to-visual-only:var(--spectrum-component-pill-edge-to-visual-only-75);--spectrum-button-sized-edge-to-text:calc(var(--spectrum-component-pill-edge-to-text-75) - var(--spectrum-button-border-width));--spectrum-button-sized-padding-label-to-icon:var(--spectrum-text-to-visual-75);--spectrum-button-sized-top-to-text:var(--spectrum-button-top-to-text-small);--spectrum-button-sized-bottom-to-text:var(--spectrum-button-bottom-to-text-small);--spectrum-button-sized-top-to-icon:var(--spectrum-component-top-to-workflow-icon-75);--spectrum-button-intended-icon-size:var(--spectrum-workflow-icon-size-75);--spectrum-icon-size:var(--spectrum-workflow-icon-size-75)}.spectrum-Button--sizeL,::slotted(.spectrum-Button--sizeL){--spectrum-button-sized-height:var(--spectrum-component-height-200);--spectrum-button-sized-font-size:var(--spectrum-font-size-200);--spectrum-button-sized-edge-to-visual:calc(var(--spectrum-component-pill-edge-to-visual-200) - var(--spectrum-button-border-width));--spectrum-button-sized-edge-to-visual-only:var(--spectrum-component-pill-edge-to-visual-only-200);--spectrum-button-sized-edge-to-text:calc(var(--spectrum-component-pill-edge-to-text-200) - var(--spectrum-button-border-width));--spectrum-button-sized-padding-label-to-icon:var(--spectrum-text-to-visual-200);--spectrum-button-sized-top-to-text:var(--spectrum-button-top-to-text-large);--spectrum-button-sized-bottom-to-text:var(--spectrum-button-bottom-to-text-large);--spectrum-button-sized-top-to-icon:var(--spectrum-component-top-to-workflow-icon-200);--spectrum-button-intended-icon-size:var(--spectrum-workflow-icon-size-200);--spectrum-icon-size:var(--spectrum-workflow-icon-size-200)}.spectrum-Button--sizeXL,::slotted(.spectrum-Button--sizeXL){--spectrum-button-sized-height:var(--spectrum-component-height-300);--spectrum-button-sized-font-size:var(--spectrum-font-size-300);--spectrum-button-sized-edge-to-visual:calc(var(--spectrum-component-pill-edge-to-visual-300) - var(--spectrum-button-border-width));--spectrum-button-sized-edge-to-visual-only:var(--spectrum-component-pill-edge-to-visual-only-300);--spectrum-button-sized-edge-to-text:calc(var(--spectrum-component-pill-edge-to-text-300) - var(--spectrum-button-border-width));--spectrum-button-sized-padding-label-to-icon:var(--spectrum-text-to-visual-300);--spectrum-button-sized-top-to-text:var(--spectrum-button-top-to-text-extra-large);--spectrum-button-sized-bottom-to-text:var(--spectrum-button-bottom-to-text-extra-large);--spectrum-button-sized-top-to-icon:var(--spectrum-component-top-to-workflow-icon-300);--spectrum-button-intended-icon-size:var(--spectrum-workflow-icon-size-300);--spectrum-icon-size:var(--spectrum-workflow-icon-size-300)}.spectrum-Button--accent,::slotted(.spectrum-Button--accent){--spectrum-button-background-color-default:var(--spectrum-accent-background-color-default);--spectrum-button-background-color-hover:var(--spectrum-accent-background-color-hover);--spectrum-button-background-color-down:var(--spectrum-accent-background-color-down);--spectrum-button-background-color-focus:var(--spectrum-accent-background-color-key-focus);--spectrum-button-border-color-default:transparent;--spectrum-button-border-color-hover:transparent;--spectrum-button-border-color-down:transparent;--spectrum-button-border-color-focus:transparent;--spectrum-button-content-color-default:var(--spectrum-white);--spectrum-button-content-color-hover:var(--spectrum-white);--spectrum-button-content-color-down:var(--spectrum-white);--spectrum-button-content-color-focus:var(--spectrum-white)}.spectrum-Button--accent.spectrum-Button--outline,::slotted(.spectrum-Button--accent.spectrum-Button--outline){--spectrum-button-background-color-hover:var(--spectrum-accent-color-200);--spectrum-button-background-color-down:var(--spectrum-accent-color-300);--spectrum-button-background-color-focus:var(--spectrum-accent-color-200);--spectrum-button-border-color-default:var(--spectrum-accent-color-900);--spectrum-button-border-color-hover:var(--spectrum-accent-color-1000);--spectrum-button-border-color-down:var(--spectrum-accent-color-1100);--spectrum-button-border-color-focus:var(--spectrum-accent-color-1000);--spectrum-button-content-color-default:var(--spectrum-accent-content-color-default);--spectrum-button-content-color-hover:var(--spectrum-accent-content-color-hover);--spectrum-button-content-color-down:var(--spectrum-accent-content-color-down);--spectrum-button-content-color-focus:var(--spectrum-accent-content-color-key-focus)}.spectrum-Button--negative,::slotted(.spectrum-Button--negative){--spectrum-button-background-color-default:var(--spectrum-negative-background-color-default);--spectrum-button-background-color-hover:var(--spectrum-negative-background-color-hover);--spectrum-button-background-color-down:var(--spectrum-negative-background-color-down);--spectrum-button-background-color-focus:var(--spectrum-negative-background-color-key-focus);--spectrum-button-border-color-default:transparent;--spectrum-button-border-color-hover:transparent;--spectrum-button-border-color-down:transparent;--spectrum-button-border-color-focus:transparent;--spectrum-button-content-color-default:var(--spectrum-white);--spectrum-button-content-color-hover:var(--spectrum-white);--spectrum-button-content-color-down:var(--spectrum-white);--spectrum-button-content-color-focus:var(--spectrum-white)}.spectrum-Button--negative.spectrum-Button--outline,::slotted(.spectrum-Button--negative.spectrum-Button--outline){--spectrum-button-background-color-hover:var(--spectrum-negative-color-200);--spectrum-button-background-color-down:var(--spectrum-negative-color-300);--spectrum-button-background-color-focus:var(--spectrum-negative-color-200);--spectrum-button-border-color-default:var(--spectrum-negative-color-900);--spectrum-button-border-color-hover:var(--spectrum-negative-color-1000);--spectrum-button-border-color-down:var(--spectrum-negative-color-1100);--spectrum-button-border-color-focus:var(--spectrum-negative-color-1000);--spectrum-button-content-color-default:var(--spectrum-negative-content-color-default);--spectrum-button-content-color-hover:var(--spectrum-negative-content-color-hover);--spectrum-button-content-color-down:var(--spectrum-negative-content-color-down);--spectrum-button-content-color-focus:var(--spectrum-negative-content-color-key-focus)}.spectrum-Button--primary,::slotted(.spectrum-Button--primary){--spectrum-button-background-color-default:var(--spectrum-neutral-background-color-default);--spectrum-button-background-color-hover:var(--spectrum-neutral-background-color-hover);--spectrum-button-background-color-down:var(--spectrum-neutral-background-color-down);--spectrum-button-background-color-focus:var(--spectrum-neutral-background-color-key-focus);--spectrum-button-border-color-default:transparent;--spectrum-button-border-color-hover:transparent;--spectrum-button-border-color-down:transparent;--spectrum-button-border-color-focus:transparent;--spectrum-button-content-color-default:var(--system-button-primary-content-color-default);--spectrum-button-content-color-hover:var(--system-button-primary-content-color-hover);--spectrum-button-content-color-down:var(--system-button-primary-content-color-down);--spectrum-button-content-color-focus:var(--system-button-primary-content-color-focus)}.spectrum-Button--primary.spectrum-Button--outline,::slotted(.spectrum-Button--primary.spectrum-Button--outline){--spectrum-button-border-color-default:var(--spectrum-gray-800);--spectrum-button-border-color-hover:var(--spectrum-gray-900);--spectrum-button-border-color-down:var(--spectrum-gray-900);--spectrum-button-border-color-focus:var(--spectrum-gray-900);--spectrum-button-content-color-default:var(--spectrum-neutral-content-color-default);--spectrum-button-content-color-hover:var(--spectrum-neutral-content-color-hover);--spectrum-button-content-color-down:var(--spectrum-neutral-content-color-down);--spectrum-button-content-color-focus:var(--spectrum-neutral-content-color-key-focus);--spectrum-button-background-color-hover:var(--system-button-primary-outline-background-color-hover);--spectrum-button-background-color-down:var(--system-button-primary-outline-background-color-down);--spectrum-button-background-color-focus:var(--system-button-primary-outline-background-color-focus)}.spectrum-Button--secondary,::slotted(.spectrum-Button--secondary){--spectrum-button-border-color-default:transparent;--spectrum-button-border-color-hover:transparent;--spectrum-button-border-color-down:transparent;--spectrum-button-border-color-focus:transparent;--spectrum-button-content-color-default:var(--spectrum-neutral-content-color-default);--spectrum-button-content-color-hover:var(--spectrum-neutral-content-color-hover);--spectrum-button-content-color-down:var(--spectrum-neutral-content-color-down);--spectrum-button-content-color-focus:var(--spectrum-neutral-content-color-key-focus);--spectrum-button-background-color-default:var(--system-button-secondary-background-color-default);--spectrum-button-background-color-hover:var(--system-button-secondary-background-color-hover);--spectrum-button-background-color-down:var(--system-button-secondary-background-color-down);--spectrum-button-background-color-focus:var(--system-button-secondary-background-color-focus)}.spectrum-Button--secondary.spectrum-Button--outline,::slotted(.spectrum-Button--secondary.spectrum-Button--outline){--spectrum-button-border-color-hover:var(--spectrum-gray-400);--spectrum-button-border-color-focus:var(--spectrum-gray-400);--spectrum-button-content-color-default:var(--spectrum-neutral-content-color-default);--spectrum-button-content-color-hover:var(--spectrum-neutral-content-color-hover);--spectrum-button-content-color-down:var(--spectrum-neutral-content-color-down);--spectrum-button-content-color-focus:var(--spectrum-neutral-content-color-key-focus);--spectrum-button-background-color-hover:var(--system-button-secondary-outline-background-color-hover);--spectrum-button-background-color-down:var(--system-button-secondary-outline-background-color-down);--spectrum-button-background-color-focus:var(--system-button-secondary-outline-background-color-focus);--spectrum-button-border-color-default:var(--system-button-secondary-outline-border-color-default);--spectrum-button-border-color-down:var(--system-button-secondary-outline-border-color-down)}.spectrum-Button--outline,::slotted(.spectrum-Button--outline),.spectrum-Button--quiet,::slotted(.spectrum-Button--quiet){--spectrum-button-background-color-default:transparent}.spectrum-Button--quiet,::slotted(.spectrum-Button--quiet){--spectrum-button-background-color-hover:var(--spectrum-gray-200);--spectrum-button-background-color-down:var(--spectrum-gray-300);--spectrum-button-background-color-focus:var(--spectrum-gray-200)}.spectrum-Button--staticWhite,::slotted(.spectrum-Button--staticWhite){--spectrum-button-focus-indicator-color:var(--spectrum-static-white-focus-indicator-color);--spectrum-button-background-color-default:var(--system-button-static-white-background-color-default);--spectrum-button-background-color-hover:var(--system-button-static-white-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-white-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-white-background-color-focus);--spectrum-button-content-color-default:var(--system-button-static-white-content-color-default);--spectrum-button-content-color-hover:var(--system-button-static-white-content-color-hover);--spectrum-button-content-color-down:var(--system-button-static-white-content-color-down);--spectrum-button-content-color-focus:var(--system-button-static-white-content-color-focus)}.spectrum-Button--staticWhite.spectrum-Button--outline,::slotted(.spectrum-Button--staticWhite.spectrum-Button--outline){--spectrum-button-background-color-default:var(--system-button-static-white-outline-background-color-default);--spectrum-button-background-color-hover:var(--system-button-static-white-outline-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-white-outline-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-white-outline-background-color-focus);--spectrum-button-content-color-default:var(--system-button-static-white-outline-content-color-default);--spectrum-button-content-color-hover:var(--system-button-static-white-outline-content-color-hover);--spectrum-button-content-color-down:var(--system-button-static-white-outline-content-color-down);--spectrum-button-content-color-focus:var(--system-button-static-white-outline-content-color-focus);--spectrum-button-border-color-default:var(--system-button-static-white-outline-border-color-default);--spectrum-button-border-color-hover:var(--system-button-static-white-outline-border-color-hover);--spectrum-button-border-color-down:var(--system-button-static-white-outline-border-color-down);--spectrum-button-border-color-focus:var(--system-button-static-white-outline-border-color-focus)}.spectrum-Button--staticWhite.spectrum-Button--secondary.spectrum-Button--outline,::slotted(.spectrum-Button--staticWhite.spectrum-Button--secondary.spectrum-Button--outline){--spectrum-button-border-color-default:var(--system-button-static-white-secondary-outline-border-color-default);--spectrum-button-border-color-hover:var(--system-button-static-white-secondary-outline-border-color-hover);--spectrum-button-border-color-down:var(--system-button-static-white-secondary-outline-border-color-down);--spectrum-button-border-color-focus:var(--system-button-static-white-secondary-outline-border-color-focus);--spectrum-button-background-color-default:transparent;--spectrum-button-background-color-hover:var(--system-button-static-white-secondary-outline-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-white-secondary-outline-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-white-secondary-outline-background-color-focus)}.spectrum-Button--staticBlack,::slotted(.spectrum-Button--staticBlack){--spectrum-button-focus-indicator-color:var(--mod-static-black-focus-indicator-color,var(--spectrum-static-black-focus-indicator-color));--spectrum-button-background-color-default:var(--system-button-static-black-background-color-default);--spectrum-button-background-color-hover:var(--system-button-static-black-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-black-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-black-background-color-focus);--spectrum-button-content-color-default:var(--system-button-static-black-content-color-default);--spectrum-button-content-color-hover:var(--system-button-static-black-content-color-hover);--spectrum-button-content-color-down:var(--system-button-static-black-content-color-down);--spectrum-button-content-color-focus:var(--system-button-static-black-content-color-focus)}.spectrum-Button--staticBlack.spectrum-Button--outline,::slotted(.spectrum-Button--staticBlack.spectrum-Button--outline){--spectrum-button-background-color-default:var(--system-button-static-black-outline-background-color-default);--spectrum-button-background-color-hover:var(--system-button-static-black-outline-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-black-outline-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-black-outline-background-color-focus);--spectrum-button-content-color-default:var(--system-button-static-black-outline-content-color-default);--spectrum-button-content-color-hover:var(--system-button-static-black-outline-content-color-hover);--spectrum-button-content-color-down:var(--system-button-static-black-outline-content-color-down);--spectrum-button-content-color-focus:var(--system-button-static-black-outline-content-color-focus);--spectrum-button-border-color-default:var(--system-button-static-black-outline-border-color-default);--spectrum-button-border-color-hover:var(--system-button-static-black-outline-border-color-hover);--spectrum-button-border-color-down:var(--system-button-static-black-outline-border-color-down);--spectrum-button-border-color-focus:var(--system-button-static-black-outline-border-color-focus)}.spectrum-Button--staticBlack.spectrum-Button--secondary,::slotted(.spectrum-Button--staticBlack.spectrum-Button--secondary){--spectrum-button-background-color-default:var(--system-button-static-black-secondary-background-color-default);--spectrum-button-background-color-hover:var(--system-button-static-black-secondary-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-black-secondary-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-black-secondary-background-color-focus);--spectrum-button-content-color-default:var(--system-button-static-black-secondary-content-color-default);--spectrum-button-content-color-hover:var(--system-button-static-black-secondary-content-color-hover);--spectrum-button-content-color-down:var(--system-button-static-black-secondary-content-color-down);--spectrum-button-content-color-focus:var(--system-button-static-black-secondary-content-color-focus)}.spectrum-Button--staticBlack.spectrum-Button--secondary.spectrum-Button--outline,::slotted(.spectrum-Button--staticBlack.spectrum-Button--secondary.spectrum-Button--outline){--spectrum-button-border-color-default:var(--system-button-static-black-secondary-outline-border-color-default);--spectrum-button-border-color-hover:var(--system-button-static-black-secondary-outline-border-color-hover);--spectrum-button-border-color-down:var(--system-button-static-black-secondary-outline-border-color-down);--spectrum-button-border-color-focus:var(--system-button-static-black-secondary-outline-border-color-focus);--spectrum-button-background-color-default:transparent;--spectrum-button-background-color-hover:var(--system-button-static-black-secondary-outline-background-color-hover);--spectrum-button-background-color-down:var(--system-button-static-black-secondary-outline-background-color-down);--spectrum-button-background-color-focus:var(--system-button-static-black-secondary-outline-background-color-focus)}.spectrum-Button--quiet,::slotted(.spectrum-Button--quiet),.spectrum-Button--staticWhite,::slotted(.spectrum-Button--staticWhite),.spectrum-Button--staticBlack,::slotted(.spectrum-Button--staticBlack),.spectrum-Button--staticWhite.spectrum-Button--secondary,::slotted(.spectrum-Button--staticWhite.spectrum-Button--secondary),.spectrum-Button--staticBlack.spectrum-Button--secondary,::slotted(.spectrum-Button--staticBlack.spectrum-Button--secondary),.spectrum-Button--staticWhite.spectrum-Button--quiet,::slotted(.spectrum-Button--staticWhite.spectrum-Button--quiet),.spectrum-Button--staticBlack.spectrum-Button--quiet,::slotted(.spectrum-Button--staticBlack.spectrum-Button--quiet){--spectrum-button-border-color-default:transparent;--spectrum-button-border-color-hover:transparent;--spectrum-button-border-color-down:transparent;--spectrum-button-border-color-focus:transparent}.markup{background:var(--spectrum-gray-75);border-top:1px solid var(--spectrum-gray-100);border-radius:6px;max-width:100%;padding:.75rem 1.5rem;line-height:1.3em;position:relative;overflow:auto hidden}div+.markup{border-radius:0 0 6px 6px}:host{border:1px solid var(--spectrum-gray-100);border-radius:var(--code-example-border-radius);--code-example-border-radius:calc(var(--swc-scale-factor)*4px);flex-direction:column;width:100%;margin:1rem 0 2rem;display:flex;position:relative}.demo-example{z-index:1;max-width:100%;padding:calc(var(--swc-scale-factor)*32px)calc(var(--swc-scale-factor)*40px);background:var(--spectrum-gray-100);border-radius:var(--code-example-border-radius)var(--code-example-border-radius)0 0;flex:1;position:relative;overflow:auto}.demo-example .flex{display:flex}@media (width<=768px){.demo-example{padding:calc(var(--swc-scale-factor)*16px)}}.markup{background:var(--spectrum-gray-75);border-top:1px solid var(--spectrum-gray-100);border-radius:0 0 6px 6px;grid-template-rows:minmax(60px,100%);grid-template-columns:100%;padding:.75rem 1.5rem;line-height:1.3em;display:grid;position:relative;overflow:auto}pre{padding-bottom:calc(.75rem + var(--swc-scale-factor)*32px);grid-area:1/1/1/1}.copy-holder{pointer-events:none;grid-area:1/1/1/1;grid-template-rows:100%;grid-template-columns:100%;width:100%;height:100%;display:grid;position:sticky;top:0;left:0}pre{font-family:var(--mod-code-font-family,var(--spectrum-code-font-family));font-size:var(--mod-code-font-size,var(--spectrum-code-font-size));font-style:var(--mod-code-font-style,var(--spectrum-code-font-style));font-weight:var(--mod-code-font-weight,var(--spectrum-code-font-weight));line-height:var(--mod-code-line-height,var(--spectrum-code-line-height));color:var(--highcontrast-code-font-color,var(--mod-code-font-color,var(--spectrum-code-font-color)))}.copy{pointer-events:all;place-self:end;margin:0 -1em -.25em 0}`;
var code_example_default = styles2;

// src/components/code-example-dark.css
import { css as css4 } from "lit";
var styles3 = css4`code[class*=language-],pre[class*=language-]{color:#f8f8f2;text-shadow:0 1px #0000004d;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none;background:0 0;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;font-size:1em;line-height:1.5}pre[class*=language-]{border-radius:.3em;margin:.5em 0;padding:1em;overflow:auto}:not(pre)>code[class*=language-],pre[class*=language-]{background:#272822}:not(pre)>code[class*=language-]{white-space:normal;border-radius:.3em;padding:.1em}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#8292a2}.token.punctuation{color:#f8f8f2}.token.namespace{opacity:.7}.token.property,.token.tag,.token.constant,.token.symbol,.token.deleted{color:#f92672}.token.boolean,.token.number{color:#ae81ff}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#a6e22e}.token.operator,.token.entity,.token.url,.language-css .token.string,.style .token.string,.token.variable{color:#f8f8f2}.token.atrule,.token.attr-value,.token.function,.token.class-name{color:#e6db74}.token.keyword{color:#66d9ef}.token.regex,.token.important{color:#fd971f}.token.important,.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}`;
var code_example_dark_default = styles3;

// src/components/code-example-light.css
import { css as css5 } from "lit";
var styles4 = css5`code[class*=language-],pre[class*=language-]{color:#000;text-shadow:0 1px #fff;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none;background:0 0;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;font-size:1em;line-height:1.5}pre[class*=language-]::-moz-selection,pre[class*=language-] ::-moz-selection,code[class*=language-]::-moz-selection,code[class*=language-] ::-moz-selection{text-shadow:none;background:#b3d4fc}pre[class*=language-]::selection,pre[class*=language-] ::selection,code[class*=language-]::selection,code[class*=language-] ::selection{text-shadow:none;background:#b3d4fc}@media print{code[class*=language-],pre[class*=language-]{text-shadow:none}}pre[class*=language-]{margin:.5em 0;padding:1em;overflow:auto}:not(pre)>code[class*=language-],pre[class*=language-]{background:#f5f2f0}:not(pre)>code[class*=language-]{white-space:normal;border-radius:.3em;padding:.1em}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#708090}.token.namespace{opacity:.7}.token.property,.token.tag,.token.boolean,.token.number,.token.constant,.token.symbol,.token.deleted{color:#905}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#690}.token.operator,.token.entity,.token.url,.language-css .token.string,.style .token.string{color:#9a6e3a;background:#ffffff80}.token.atrule,.token.attr-value,.token.keyword{color:#07a}.token.function,.token.class-name{color:#dd4a68}.token.regex,.token.important,.token.variable{color:#e90}.token.important,.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}.token.attr-name,.token.builtin,.token.char,.token.inserted,.token.selector,.token.string{color:#567f01}.token.punctuation{color:#737373}.language-css .token.function{color:inherit}`;
var code_example_light_default = styles4;

// src/components/code-example.ts
var CodeExample = class extends FocusVisiblePolyfillMixin(LitElement2) {
  constructor() {
    super(...arguments);
    this.codeTheme = "light";
    this.preprocessed = false;
    this.noDemo = false;
    this.prismjsLoaded = false;
    this.liveHTMLTransferred = false;
    this.shouldManageTabOrderForScrolling = () => {
      [this.markup, this.demo].map((el) => {
        if (!el) {
          return;
        }
        const { offsetWidth, scrollWidth } = el;
        if (offsetWidth < scrollWidth) {
          el.tabIndex = 0;
        } else {
          el.removeAttribute("tabindex");
        }
      });
    };
  }
  static get styles() {
    return [code_example_default];
  }
  get codeSlot() {
    const code = [...this.children || []].find(
      (child) => child.slot === "code"
    );
    return code || this;
  }
  get highlightedHTML() {
    const el = this.codeSlot;
    return el.innerHTML || "";
  }
  get liveHTML() {
    const el = this.codeSlot;
    return el.textContent || "";
  }
  get language() {
    if (this.classList.contains("language-javascript")) {
      return "javascript";
    }
    return "markup";
  }
  get showDemo() {
    if (this.noDemo) {
      return false;
    }
    return this.classList.contains("language-html") || this.classList.contains("language-html-live");
  }
  get highlightedCode() {
    const highlightedHTML = this.preprocessed ? this.highlightedHTML : window.Prism.highlight(
      this.liveHTML,
      window.Prism.languages[this.language],
      this.language
    );
    const code = toHtmlTemplateString(highlightedHTML);
    return html3`
      <pre><code>${code}</code></pre>
    `;
  }
  get renderedCode() {
    if (this.classList.contains("language-html-live") && !this.liveHTMLTransferred) {
      const demo = this.querySelector('[slot="demo"]') || document.createElement("div");
      demo.slot = "demo";
      demo.innerHTML = this.liveHTML;
      this.append(demo);
      this.liveHTMLTransferred = true;
    }
    return toHtmlTemplateString(this.liveHTML);
  }
  shouldUpdate() {
    if (this.preprocessed || this.prismjsLoaded) {
      return true;
    }
    if (!this.preprocessed) {
      import("./prism-VRAYCELB.js").then(() => {
        this.prismjsLoaded = true;
        this.requestUpdate();
      });
    }
    return false;
  }
  render() {
    const { highlightedCode, renderedCode } = this;
    return html3`
      ${this.showDemo ? html3`
            <div class="demo-example">
              <slot name="demo">${renderedCode}</slot>
            </div>
          ` : void 0}
      <bdo class="markup">
        ${highlightedCode}
        <div class="copy-holder">
          <sp-action-button class="copy" @click=${this.copyToClipboard} quiet>
            <sp-icon-copy slot="icon"></sp-icon-copy>
            Copy to Clipboard
          </sp-action-button>
        </div>
      </bdo>
      <style>
        ${this.codeTheme === "light" ? code_example_light_default.toString() : code_example_dark_default.toString()}
      </style>
    `;
  }
  copyToClipboard() {
    copyNode(this);
  }
  updated() {
    setTimeout(this.shouldManageTabOrderForScrolling);
  }
  trackTheme() {
    const queryThemeEvent = new CustomEvent("sp-track-theme", {
      bubbles: true,
      composed: true,
      detail: {
        callback: (color) => {
          this.codeTheme = color.startsWith("light") ? "light" : "dark";
        }
      },
      cancelable: true
    });
    this.dispatchEvent(queryThemeEvent);
  }
  connectedCallback() {
    super.connectedCallback?.();
    window.addEventListener("resize", this.shouldManageTabOrderForScrolling);
    this.trackTheme();
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.shouldManageTabOrderForScrolling);
    this.trackTheme();
    super.disconnectedCallback?.();
  }
};
__decorateClass([
  query("#markup")
], CodeExample.prototype, "markup", 2);
__decorateClass([
  query(".demo-example")
], CodeExample.prototype, "demo", 2);
__decorateClass([
  property2()
], CodeExample.prototype, "codeTheme", 2);
__decorateClass([
  property2({ type: Boolean })
], CodeExample.prototype, "preprocessed", 2);
__decorateClass([
  property2({ type: Boolean, attribute: "no-demo" })
], CodeExample.prototype, "noDemo", 2);
CodeExample = __decorateClass([
  customElement2("code-example")
], CodeExample);

// src/components/layout.css
import { css as css6 } from "lit";
var styles5 = css6`:host{min-height:100dvh;display:block}#app{flex-direction:column;width:100%;height:100%;min-height:100dvh;display:flex}docs-side-nav:not(:defined){display:none}@media screen and (width>=961px){docs-side-nav:not(:defined){max-width:calc(var(--swc-scale-factor)*192px);background-color:var(--spectrum-gray-75);flex-direction:column;height:100vh;max-height:100vh;padding:0 24px 24px;display:flex;position:sticky;top:0;left:0}docs-side-nav:not(:defined) ::slotted([slot=logo]){margin:0 -24px}docs-side-nav:not(:defined) ::slotted([slot=side-nav]){flex:1;width:216px;margin-top:56px}}#body{grid-template-columns:auto calc(100% - var(--swc-scale-factor)*240px);color:var(--spectrum-gray-800);background-color:var(--spectrum-gray-50);flex:auto;display:grid}@media screen and (width<=960px){#body{grid-template-columns:100%;height:50%}}#page{box-sizing:border-box;width:100%;max-width:1080px;padding:calc(var(--swc-scale-factor)*40px)calc(var(--swc-scale-factor)*56px);margin-left:auto;margin-right:auto}.manage-theme{grid-template-columns:auto auto;justify-content:flex-end;min-height:52px;display:grid}.theme-control{flex-direction:column;display:flex}@media screen and (width<=960px){#page{padding:calc(var(--swc-scale-factor)*8px)calc(var(--swc-scale-factor)*24px)}.manage-theme{margin-left:0;margin-right:0}}@media screen and (width>=525px){.manage-theme{flex-flow:wrap;display:flex}}header{z-index:2;min-height:calc(var(--swc-scale-factor)*48px);background-color:var(--spectrum-gray-50);border-bottom:1px solid var(--spectrum-gray-200);--spectrum-actionbutton-height:calc(var(--swc-scale-factor)*40px);--spectrum-actionbutton-min-width:calc(var(--swc-scale-factor)*40px);--spectrum-alias-workflow-icon-size:22px;flex-direction:row;justify-content:space-between;align-items:center;padding-inline:8px;display:flex;position:sticky;top:0;left:0;right:0}header svg{stroke:#0000;height:100%}.theme-control{margin-inline-start:calc(var(--swc-scale-factor)*32px)}sp-field-label:not(:defined){min-width:70px;height:calc(var(--spectrum-fieldlabel-m-text-line-height,var(--spectrum-alias-component-text-line-height)) + var(--spectrum-fieldlabel-m-padding-top,calc(var(--swc-scale-factor)*4px)) + var(--spectrum-fieldlabel-m-padding-bottom,calc(var(--swc-scale-factor)*5px)))}sp-picker:not(:defined){min-width:70px;height:var(--spectrum-picker-m-height,var(--spectrum-alias-item-height-m))}sp-picker:not(:defined) sp-menu-item{display:none}@media screen and (width>=961px){header{display:none}}.alerts{text-align:center;flex-direction:column;width:100vw;display:flex;position:fixed;bottom:0}.alerts sp-toast{margin:0 auto calc(var(--swc-scale-factor)*24px)}#logo{width:calc(var(--swc-scale-factor)*192px);padding:calc(var(--swc-scale-factor)*28px)calc(var(--swc-scale-factor)*24px);color:var(--spectrum-gray-800);border-radius:4px;outline:none;flex-direction:row;margin-bottom:-11px;text-decoration:none;display:flex}#logo docs-spectrum-logo{width:36px;height:31px;margin-right:calc(var(--swc-scale-factor)*16px);flex-shrink:0;margin-bottom:12px;display:block}#logo .title{font-family:var(--spectrum-alias-body-text-font-family,var(--spectrum-font-family));letter-spacing:0;align-items:center;margin:-3px 0 0;font-size:18px;font-style:normal;font-weight:700;line-height:1.3}#logo span{white-space:nowrap}aside{visibility:visible;z-index:10;width:calc(var(--swc-scale-factor)*192px);background-color:var(--spectrum-gray-75);height:100vh;max-height:100vh;transition:transform var(--spectrum-dialog-confirm-background-entry-animation-duration,var(--spectrum-animation-duration-600))cubic-bezier(0,0,.4,1),visibility 0s linear var(--spectrum-dialog-confirm-background-entry-animation-duration,var(--spectrum-animation-duration-600));flex-direction:column;display:flex;position:fixed;top:0;right:0;overflow:auto}aside .manage-theme{flex-direction:column;order:1;padding:0 24px 24px;display:flex}.scrim{z-index:10;touch-action:none;position:fixed}aside header{background:0 0;border-color:#0000;justify-content:end;padding-inline:8px}aside .theme-control{margin:0 0 calc(var(--swc-scale-factor)*24px)}sp-underlay[open]+aside{visibility:visible;transition-delay:0s,0s}sp-underlay:not([open])+aside{visibility:hidden;transform:translate(100%)}aside:dir(rtl){left:0;right:auto}sp-underlay:not([open])+aside:dir(rtl){transform:translate(-100%)}`;
var layout_default = styles5;

// src/components/layout.ts
var SWC_THEME_COLOR_KEY = "swc-docs:theme:color";
var SWC_THEME_SCALE_KEY = "swc-docs:theme:scale";
var SWC_THEME_THEME_KEY = "swc-docs:theme:theme";
var SWC_THEME_SYSTEM_KEY = "swc-docs:theme:system";
var SWC_THEME_DIR_KEY = "swc-docs:theme:dir";
var COLOR_FALLBACK = matchMedia(DARK_MODE).matches ? "dark" : "light";
var SCALE_FALLBACK = matchMedia(IS_MOBILE).matches ? "large" : "medium";
var SYSTEM_FALLBACK = "spectrum";
var DIR_FALLBACK = "ltr";
var DEFAULT_COLOR = window.localStorage ? localStorage.getItem(SWC_THEME_COLOR_KEY) || COLOR_FALLBACK : COLOR_FALLBACK;
var DEFAULT_SCALE = window.localStorage ? localStorage.getItem(SWC_THEME_SCALE_KEY) || SCALE_FALLBACK : SCALE_FALLBACK;
var DEFAULT_SYSTEM = window.localStorage ? localStorage.getItem(SWC_THEME_THEME_KEY) || localStorage.getItem(SWC_THEME_SYSTEM_KEY) || SYSTEM_FALLBACK : SYSTEM_FALLBACK;
var DEFAULT_DIR = window.localStorage ? localStorage.getItem(SWC_THEME_DIR_KEY) ?? DIR_FALLBACK : DIR_FALLBACK;
var isNarrowMediaQuery = matchMedia("screen and (max-width: 960px)");
var lazyStyleFragment = (name, system) => {
  const fragmentName = `${name}-${system}`;
  switch (fragmentName) {
    case "dark-spectrum":
      import("@spectrum-web-components/theme/theme-dark.js");
      break;
    case "darkest-spectrum":
      import("@spectrum-web-components/theme/theme-dark.js");
      break;
    case "light-spectrum":
      import("@spectrum-web-components/theme/theme-light.js");
      break;
    case "lightest-spectrum":
      import("@spectrum-web-components/theme/theme-light.js");
      break;
    case "medium-spectrum":
      import("@spectrum-web-components/theme/scale-medium.js");
      break;
    case "large-spectrum":
      import("@spectrum-web-components/theme/scale-large.js");
      break;
    case "dark-express":
      import("@spectrum-web-components/theme/express/theme-dark.js");
      break;
    case "darkest-express":
      import("@spectrum-web-components/theme/express/theme-dark.js");
      break;
    case "light-express":
      import("@spectrum-web-components/theme/express/theme-light.js");
      break;
    case "lightest-express":
      import("@spectrum-web-components/theme/express/theme-light.js");
      break;
    case "medium-express":
      import("@spectrum-web-components/theme/express/scale-medium.js");
      break;
    case "large-express":
      import("@spectrum-web-components/theme/express/scale-large.js");
      break;
    case "light-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/theme-light-core-tokens.js");
      break;
    case "dark-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/theme-dark-core-tokens.js");
      break;
    case "medium-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/scale-medium-core-tokens.js");
      break;
    case "large-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/scale-large-core-tokens.js");
      break;
  }
};
var loadDefaults = () => {
  if (DEFAULT_COLOR !== COLOR_FALLBACK || DEFAULT_SCALE !== SCALE_FALLBACK || DEFAULT_SYSTEM !== SYSTEM_FALLBACK) {
    lazyStyleFragment(DEFAULT_COLOR, DEFAULT_SYSTEM);
    lazyStyleFragment(DEFAULT_SCALE, DEFAULT_SYSTEM);
  }
};
var LayoutElement = class extends LitElement3 {
  constructor() {
    super();
    this.alerts = /* @__PURE__ */ new Map();
    this.color = DEFAULT_COLOR;
    this.open = false;
    this.isNarrow = isNarrowMediaQuery.matches;
    this.theme = DEFAULT_SYSTEM;
    this.scale = DEFAULT_SCALE;
    this.system = DEFAULT_SYSTEM;
    this._themeTrackers = /* @__PURE__ */ new Map();
    this.handleMatchMediaChange = (event) => {
      this.isNarrow = event.matches;
    };
    if (["ltr", "rtl"].includes(DEFAULT_DIR)) {
      this.dir = DEFAULT_DIR;
    }
  }
  static get styles() {
    return [layout_default];
  }
  get dir() {
    return getComputedStyle(this).direction ?? DEFAULT_DIR;
  }
  set dir(dir) {
    if (dir === this.dir) {
      return;
    }
    const oldDir = this.dir;
    this.setAttribute("dir", dir);
    this.requestUpdate("dir", oldDir);
  }
  closeSettings(event) {
    event.target.parentElement?.dispatchEvent(
      new Event("close", { bubbles: true })
    );
  }
  updateColor(event) {
    this.color = event.target.value;
    this._themeTrackers.forEach((tracker) => tracker(this.color));
  }
  updateScale(event) {
    this.scale = event.target.value;
  }
  updateSystem(event) {
    this.system = event.target.value;
  }
  updateDirection(event) {
    this.dir = event.target.value;
  }
  handleTrackTheme(event) {
    const target = event.composedPath()[0];
    if (this._themeTrackers.has(target)) {
      this._themeTrackers.delete(target);
    } else {
      this._themeTrackers.set(target, event.detail.callback);
      const callback = this._themeTrackers.get(target);
      if (callback) {
        callback(this.color);
      }
    }
  }
  copyText(event) {
    copyText(event.detail.text);
    this.addAlert(event);
  }
  addAlert(event) {
    const target = event.composedPath()[0];
    if (!this.alerts.has(target)) {
      const close = () => {
        this.alerts.delete(target);
        target.focus();
        this.requestUpdate();
      };
      this.alerts.set(target, {
        count: 0,
        message: "",
        /**
         * <sp-toast> does not allow a `timeout` of less that 6000
         * use this as a cheat to reset the timeout to 6000 for
         * every additional alert.
         */
        element: (count, message) => {
          import("@spectrum-web-components/toast/sp-toast.js");
          return html4`
            <sp-toast .timeout=${count} variant="info" @close=${close} open>
              ${message} ${count > 1 ? `(${count} alerts)` : ""}
            </sp-toast>
          `;
        }
      });
    }
    const alert = this.alerts.get(target);
    this.alerts.set(target, {
      element: alert.element,
      count: alert.count + 1,
      message: event.detail.message
    });
    this.requestUpdate();
  }
  get sideNav() {
    const navContent = html4`
      <slot name="logo" slot="logo">
        <a id="logo" href="index.html">
          <docs-spectrum-logo></docs-spectrum-logo>
          <h1 class="title">
            Spectrum
            <br />
            <span>Web Components</span>
          </h1>
        </a>
      </slot>
      <slot name="side-nav"></slot>
    `;
    import("./side-nav-3GHFFMTG.js");
    return html4`
      <docs-side-nav id="side-nav" .isNarrow=${this.isNarrow}>
        ${navContent}
      </docs-side-nav>
    `;
  }
  get settingsContent() {
    import("@spectrum-web-components/underlay/sp-underlay.js");
    return html4`
      <sp-underlay class="scrim" @close=${this.closeSettings}></sp-underlay>
      <aside aria-label="Settings">
        ${this.manageTheme}
        <header>
          <sp-action-button
            quiet
            label="Close Settings"
            @click=${this.closeSettings}
            id="close-settings-id"
          >
            <sp-icon-close slot="icon"></sp-icon-close>
          </sp-action-button>
        </header>
      </aside>
    `;
  }
  get manageTheme() {
    import("./settings-IPP5ILYA.js");
    return html4`
      <div class="manage-theme" role="form" aria-label="Settings">
        <div class="theme-control">
          <sp-field-label for="theme-system">System</sp-field-label>
          <sp-picker
            id="theme-system"
            quiet
            value=${this.system}
            @change=${this.updateSystem}
          >
            <sp-menu-item value="spectrum">Spectrum</sp-menu-item>
            <sp-menu-item value="express">Express</sp-menu-item>
            <sp-menu-item value="spectrum-two">Spectrum 2</sp-menu-item>
          </sp-picker>
        </div>
        <div class="theme-control">
          <sp-field-label for="theme-color">Color</sp-field-label>
          <sp-picker
            id="theme-color"
            quiet
            value=${this.color}
            @change=${this.updateColor}
          >
            <sp-menu-item value="light">Light</sp-menu-item>
            <sp-menu-item value="dark">Dark</sp-menu-item>
          </sp-picker>
        </div>
        <div class="theme-control">
          <sp-field-label for="theme-scale">Scale</sp-field-label>
          <sp-picker
            id="theme-scale"
            label="Scale"
            quiet
            value=${this.scale}
            @change=${this.updateScale}
          >
            <sp-menu-item value="medium">Medium</sp-menu-item>
            <sp-menu-item value="large">Large</sp-menu-item>
          </sp-picker>
        </div>
        <div class="theme-control">
          <sp-field-label for="theme-direction">Direction</sp-field-label>
          <sp-picker
            id="theme-direction"
            label="Direction"
            quiet
            value=${this.dir}
            @change=${this.updateDirection}
          >
            <sp-menu-item value="ltr">LTR</sp-menu-item>
            <sp-menu-item value="rtl">RTL</sp-menu-item>
          </sp-picker>
        </div>
      </div>
    `;
  }
  get header() {
    const triggerOptions = {
      overlayOptions: {
        type: "modal"
      },
      insertionOptions: {
        el: () => this.shadowRoot?.querySelector("#body"),
        where: "afterbegin"
      }
    };
    return html4`
      <header>
        <sp-action-button
          quiet
          label="Open Navigation"
          id="toggle-nav-id"
          ${trigger(() => this.sideNav, triggerOptions)}
        >
          <sp-icon-show-menu slot="icon"></sp-icon-show-menu>
        </sp-action-button>
        <sp-action-button
          quiet
          label="Open Settings"
          id="toggle-settings-id"
          ${trigger(() => this.settingsContent, triggerOptions)}
        >
          <sp-icon-settings slot="icon"></sp-icon-settings>
        </sp-action-button>
      </header>
    `;
  }
  render() {
    return html4`
      <sp-theme
        .color=${this.color}
        .scale=${this.scale}
        .system=${this.system}
        dir=${this.dir}
        id="app"
        @sp-track-theme=${this.handleTrackTheme}
      >
        ${this.isNarrow ? this.header : html4``}
        <div id="body">
          ${this.isNarrow ? html4`` : this.sideNav}
          <div id="page" @alert=${this.addAlert} @copy-text=${this.copyText}>
            ${!this.isNarrow ? this.manageTheme : ""}
            <slot></slot>
          </div>
        </div>
        ${this.alerts.size ? html4`
              <div class="alerts" role="region">
                ${[...this.alerts.values()].map(
      (alert) => alert.element(alert.count, alert.message)
    )}
              </div>
            ` : html4``}
      </sp-theme>
    `;
  }
  firstUpdated() {
    loadDefaults();
    isNarrowMediaQuery.addEventListener("change", this.handleMatchMediaChange);
  }
  updated(changes) {
    let loadStyleFragments = false;
    if (changes.has("color")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_COLOR_KEY, this.color);
      }
      if (changes.get("color")) {
        loadStyleFragments = true;
      }
      const overview = [
        ...this.querySelectorAll("code-example")
      ];
      overview.forEach((example) => {
        const computedColor = this.color.startsWith("light") ? "light" : "dark";
        example.codeTheme = computedColor;
      });
      document.querySelector("html").style.colorScheme = this.color;
    }
    if (changes.has("scale")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_SCALE_KEY, this.scale);
      }
      if (changes.get("scale")) {
        loadStyleFragments = true;
      }
    }
    if (changes.has("system")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_SYSTEM_KEY, this.system);
      }
      if (changes.get("system")) {
        loadStyleFragments = true;
      }
    }
    if (changes.has("dir")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_DIR_KEY, this.dir);
      }
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
    if (loadStyleFragments) {
      lazyStyleFragment(this.color, this.system);
      lazyStyleFragment(this.scale, this.system);
    }
  }
};
__decorateClass([
  state()
], LayoutElement.prototype, "alerts", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "color", 2);
__decorateClass([
  property3({ type: Boolean })
], LayoutElement.prototype, "open", 2);
__decorateClass([
  state()
], LayoutElement.prototype, "isNarrow", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "theme", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "scale", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "system", 2);
customElements.define("docs-page", LayoutElement);

// src/index.ts
window.spAlert = (el, message) => {
  el.dispatchEvent(
    new CustomEvent("alert", {
      composed: true,
      bubbles: true,
      detail: {
        message
      }
    })
  );
};
